module.exports = __webpack_public_path__ + "img/bus_inactive.018ed597.svg";